import { AlternativeType } from './types'
import { alternative as IntegrationAppAlternative } from './IntegrationApp/integration-app-data'
import { alternative as ApideckAlternative } from './Apideck/apideck-data'
import { alternative as MergeAlternative } from './Merge/merge-data'
import { alternative as NangoAlternative } from './Nango/nango-data'
import { alternative as ParagonAlternative } from './Paragon/paragon-data'
import { alternative as PrismaticAlternative } from './Prismatic/prismatic-data'
import { alternative as TrayAlternative } from './Tray/tray-data'
import { alternative as WorkatoAlternative } from './Workato/workato-data'

export const alternatives: Map<string, AlternativeType> = new Map()
alternatives.set('integration', IntegrationAppAlternative)
alternatives.set('apideck', ApideckAlternative)
alternatives.set('merge', MergeAlternative)
alternatives.set('nango', NangoAlternative)
alternatives.set('paragon', ParagonAlternative)
alternatives.set('prismatic', PrismaticAlternative)
alternatives.set('tray', TrayAlternative)
alternatives.set('workato', WorkatoAlternative)

export const alternativeIds = Array.from(alternatives.keys()).filter(
  (id) => id !== 'integration',
)
